<template>
  <div>
    <CopyButton
      :text="orderNumber"
      class="bg-background-neutral-secondary w-full items-center justify-between rounded-2xl px-4 py-3 text-gray-400"
      @onCopy="copyAlertRef?.show()"
    >
      <p class="text-static-black flex flex-col text-left">
        <span
          class="text-text-neutral-primary text-lg font-semibold leading-relaxed"
        >
          {{ $t('payment.orderNumber', { order: orderNumber }) }}
        </span>
      </p>
    </CopyButton>
    <div
      class="fixed top-[calc(var(--header-height)+8px)] z-10 flex w-[calc(100%-32px)] justify-center"
    >
      <FreeAlert ref="copyAlertRef" :duration="2000">
        <template #icon>
          <img
            src="@/assets/images/green-copy-icon.svg"
            width="24"
            height="24"
            alt=""
            role="presentation"
          />
        </template>
        <p class="text-text-neutral-primary">{{ $t('payment.copied') }}</p>
      </FreeAlert>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import { CopyButton, FreeAlert } from 'freedom-shared';

  defineProps<{
    orderNumber: string;
  }>();

  const copyAlertRef = ref<InstanceType<typeof FreeAlert> | null>(null);
</script>
